import React, { Component } from 'react';
import { Text } from 'pp-react';

import styles from './donationTerms.less';

import content from '../lib/i18n';
const i18n = content('app/components/donation-terms');

import glamorous from 'glamorous';

const TermsOl = glamorous(Text)({
  listStyleType: 'disc',
  textAlign: 'left'
});

const Term = glamorous(Text)({
  margin: '10px 0px',
});

export default class DonationTerms extends Component {
  render() {
    const type = this.props.type || 'PPGF';
    const charityContent = this.props.charityContent;
    const donateTerms = this.props.charityContent ?
      charityContent.donationTerms :
      'label.donation-terms';

    let terms;
    if (type === 'PPGF_DIRECT') {
      terms = i18n('label.ppgf-direct-donation-terms');
    } else {
      terms = i18n(donateTerms);
    }

    terms = Array.isArray(terms) ? terms : [];
    return (
      <TermsOl as='ol'>
        {terms.map((term, index) => {
          return (
            <Term as='li' key={`donation-term-${index}`}>
              {term}
            </Term>
          );
        })}
      </TermsOl>
    );
  }
}
